import { $t } from "@/lib/i18nHelpers";
import { FooterLink } from "@/views/PageLanding/types";

export const policies: FooterLink[] = [
  {
    href: "/static/terms-of-use.html",
    text: $t("Terms Of Use"),
  },
  {
    href: "/static/cookie-policy.html",
    text: $t("Cookie Policy"),
  },
  {
    href: "/static/privacy-policy.html",
    text: $t("Privacy Policy"),
  },
  {
    href: "/static/refund-policy.html",
    text: $t("Refund Policy"),
  },
  {
    href: "/static/security-policy.html",
    text: $t("Security Policy"),
  },
];

export const company: FooterLink[] = [
  {
    href: "mailto:hello@wideapp.co",
    text: $t("Email us"),
  },
  {
    href: "/static/wide-content-guidelines.html",
    text: $t("Content Guidelines"),
  },
  {
    href: "https://www.wideapp.co/messages/1",
    text: $t("Contact us on Wide"),
  },
];

export const socialLinks: FooterLink[] = [
  {
    href: "https://www.instagram.com/widenetwrk/",
    text: $t("Instagram"),
  },
];
